import * as React from "react";
import type { SVGProps } from "react";
const SvgJacuzziIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M18.48 3.92a2.247 2.247 0 0 0-2.24 2.24 2.247 2.247 0 0 0 2.24 2.24 2.247 2.247 0 0 0 2.24-2.24 2.247 2.247 0 0 0-2.24-2.24m0 1.12c.626 0 1.12.494 1.12 1.12s-.494 1.12-1.12 1.12-1.12-.494-1.12-1.12.494-1.12 1.12-1.12M0 6.16v1.12h.56c.31 0 .56.25.56.56v11.2c0 2.77 2.27 5.04 5.04 5.04h15.68c2.77 0 5.04-2.27 5.04-5.04V7.84c0-.31.25-.56.56-.56H28V6.16h-.56c-.92 0-1.68.759-1.68 1.68v1.82c-.78.234-3.034.805-6.825.805-3.017 0-4.788-.554-7.787-.805A2.23 2.23 0 0 0 8.96 7.84c-1.07 0-1.97.759-2.188 1.767a19.6 19.6 0 0 0-4.532.823V7.84c0-.921-.76-1.68-1.68-1.68zm8.96 2.8c.626 0 1.12.494 1.12 1.12s-.494 1.12-1.12 1.12-1.12-.494-1.12-1.12.494-1.12 1.12-1.12m-2.135 1.767A2.24 2.24 0 0 0 8.96 12.32c.987 0 1.822-.648 2.117-1.54 2.899.245 4.71.805 7.858.805 3.404 0 5.72-.464 6.825-.753v8.208c0 2.159-1.76 3.92-3.92 3.92H6.16c-2.16 0-3.92-1.761-3.92-3.92v-7.438c.682-.234 2.398-.737 4.585-.875M19.6 14c-1.54 0-2.8 1.26-2.8 2.8s1.26 2.8 2.8 2.8 2.8-1.26 2.8-2.8-1.26-2.8-2.8-2.8m0 1.12c.934 0 1.68.746 1.68 1.68s-.746 1.68-1.68 1.68-1.68-.746-1.68-1.68.746-1.68 1.68-1.68m-8.12 1.96c-1.076 0-1.96.884-1.96 1.96S10.404 21 11.48 21s1.96-.884 1.96-1.96-.884-1.96-1.96-1.96m0 1.12c.47 0 .84.37.84.84s-.37.84-.84.84-.84-.37-.84-.84.37-.84.84-.84"
    />
  </svg>
);
export default SvgJacuzziIcon;
